module.exports = __webpack_public_path__ + "img/select-active.18f974a7.svg";